import CheckBoxPrompt from './CheckboxPrompt';

export default CheckBoxPrompt;
